import GLOBAL_SETTINGS from '../../../global-settings';
const URL = GLOBAL_SETTINGS.HOST + (GLOBAL_SETTINGS.PORT ? ':' + GLOBAL_SETTINGS.PORT : '');

function manageOrder ($scope, $rootScope, $timeout, orderModel, googleAnalytics) {
  let vm;

  class ManageOrderController {
    constructor () {
      vm = this;
      vm.loading = true;
      vm.isShownFullCard = false;
      vm.orderListColumns = [
        {
          name: 'number',
          label: 'מספר הזמנה'
        },
        {
          name: 'createdAt',
          label: 'תאריך הזמנה',
          filter: 'date'
        },
        {
          name: 'customerName',
          label: 'שם'
        },
        {
          name: 'book.name',
          label: 'ספר'
        },
        {
          name: 'sum',
          label: 'סכום לתשלום'
        },
        {
          name: 'done',
          label: 'טופל',
          filter: 'boolean'
        },
        {
          name: 'orderButton',
          filter: 'button'
        }
      ];

      // vm.buttons = [
      //   {
      //     label: 'הוספת הזמנה',
      //     click: vm.newOrder
      //   }
      // ];

      vm.initOrderList();
      $scope.$on('reload orders', () => {
        vm.initOrderList();
      });

      googleAnalytics.setPage('ניהול הזמנות', 'manage-orders');
    }

    initOrderList () {
      orderModel.list()
        .then((response) => {
          vm.orderList = response.data.data;
          vm.orderList.forEach((item) => {
            item.customerName = item.customer.lastName + ' ' + item.customer.firstName;

            if (item.cardNumber) {
              item.last4digits = item.cardNumber.slice(-4);
            }

            item.orderButton = {
              text: '<img src="data:image/svg+xml;utf8;base64,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" /> <span>טיפול בהזמנה</span>',
              click: vm.manageOrderFn
            };
          });

          vm.loading = false;
        });
    }

    clickOnRow (order) {
      vm.showOrder(order);
    }

    // newOrder () {
    //   vm.order = {};
    //   vm.orderModalBoxHeader = 'הוספת הזמנה';
    //   vm.orderModalBoxIsOpen = true;
    // }

    showOrder (order) {
      vm.order = order;
      vm.isShownFullCard = false;
      vm.orderModalBoxHeader = 'הצגת הזמנה';
      vm.orderModalBoxIsOpen = true;
    }

    // editOrder (order) {
    //   vm.order = order;
    //   vm.orderModalBoxHeader = 'עריכת הזמנה';
    //   vm.orderModalBoxIsOpen = true;
    // }

    manageOrderFn (order) {
      vm.closeModalBox();
      $timeout(() => {
        vm.order = order;
        vm.orderManageModalBoxIsOpen = true;
      });
    }

    closeModalBox () {
      $rootScope.$broadcast('modalBoxClose');
    }

    showFullCard () {
      vm.isShownFullCard = true;
    }
  }

  return new ManageOrderController();
}

export default manageOrder;
